import { Box, Grid, Stack, Typography } from "@mui/material";
import { JSX, PropsWithChildren } from "react";
import DefaultIcon from "../../images/info_page_icon.svg";
import StyledPage from "./StyledPage";

interface Props {
  title: string;
  subtitle?: JSX.Element;
  Icon?: JSX.Element;
}

const InfoPage = ({ title, subtitle, Icon, children }: PropsWithChildren<Props>) => (
  <StyledPage
    containerProps={{ alignItems: "center", justifyContent: "center", direction: "column", spacing: 3 }}
    sx={{ px: 2 }}
  >
    <Grid>
      <Stack spacing={1} alignItems="center">
        <Box mt={-20} mb={5}>
          {Icon || <img src={Icon || DefaultIcon} alt="logo" />}
        </Box>
      </Stack>
    </Grid>
    <Grid>
      <Stack spacing={1} alignItems="center">
        <Typography variant="h4">{title}</Typography>
        {subtitle}
      </Stack>
    </Grid>
    <Grid>
      <Box>{children}</Box>
    </Grid>
  </StyledPage>
);

export default InfoPage;
